import { Dispatch, SetStateAction } from 'react';
import {
  Box,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react';
import { Button } from 'components/elements/Button';
import { Text } from 'components/elements/Text';
import { CrossIcon } from 'components/icons/CrossIcon';
import { FlexColumn } from 'components/layout/FlexColumn/FlexColumn';
import { FlexRow } from 'components/layout/FlexRow';

type DeleteGroupModalProps = {
  isDeleteModal: boolean;
  setIsDeleteModal: Dispatch<SetStateAction<boolean>>;
  isLoading?: boolean;
  onDeleteClick?: () => void;
};

export const DeleteGroupModal = ({
  isDeleteModal,
  setIsDeleteModal,
  isLoading,
  onDeleteClick,
}: DeleteGroupModalProps) => (
  <Modal isOpen={isDeleteModal} onClose={() => setIsDeleteModal(!isDeleteModal)}>
    <ModalOverlay sx={{ backdropFilter: 'blur(2rem)' }} />
    <ModalContent
      sx={{
        borderRadius: '8px',
        boxSizing: 'border-box',
      }}
    >
      <FlexColumn sx={{ height: '100%' }} justifyContent="flex-start" alignItems="center">
        <ModalHeader sx={{ width: '100%', margin: '0px', padding: '17px 16px 0px' }}>
          <FlexRow alignItems="center" justifyContent="space-between">
            <Text
              sx={{ fontSize: '16px', lineHeight: '18px', letterSpacing: '-0,02em' }}
              fontWeight={600}
            >
              Are you sure you want to delete this?
            </Text>
            <Box
              sx={{ cursor: 'pointer' }}
              onClick={() => setIsDeleteModal(!isDeleteModal)}
            >
              <CrossIcon stroke="#2C402E" opacity={0.2} />
            </Box>
          </FlexRow>
        </ModalHeader>
        <ModalBody sx={{ width: '100%', padding: '16px' }}>
          <Text marginBottom="24px">This action cannot be undone.</Text>
          <FlexRow justifyContent="normal">
            <Button
              color="secondary"
              onClick={() => setIsDeleteModal(!isDeleteModal)}
              sx={{
                color: 'brand.army-green',
                mr: '0.8rem',
                padding: '16px',
                height: '100%',
              }}
            >
              Cancel
            </Button>
            <Button
              disabled={isLoading}
              color="primary"
              type="submit"
              sx={{
                backgroundColor: 'brand.army-green',
                color: 'brand.white',
                padding: '16px',
                height: '100%',
              }}
              onClick={onDeleteClick}
            >
              Yes, delete
            </Button>
          </FlexRow>
        </ModalBody>
      </FlexColumn>
    </ModalContent>
  </Modal>
);
